// Копирайт профиля — spec/08_copy.md, раздел «Статистика и профиль» (часть profile.*).
// Голос — вариант A «своя в чате» (docs/copy-variants.md). Отпуск — тревожная зона: там
// формулировки остаются спокойными.
// Пол пользовательницы: строка «Кого ты проверяла» была женской для всех.
import { textByGender } from '@lunya/contracts'

import type { ProfileCopy } from './types'

export const profile: ProfileCopy = {
  vacation: 'Я в отпуске 🏝',
  vacation_sub: 'Близкие увидят, что ты в отпуске, и не будут переживать',
  vacation_till: 'До какого',
  vacation_body: ({ gender }) =>
    textByGender(
      gender,
      'Я обо всех помню и люблю, просто {убрал|убрала} телефон подальше',
      'Я обо всех помню и люблю, просто убираю телефон подальше',
    ),
  vacation_cta: 'Уйти в отпуск',
  vacation_note: ({ date }) =>
    `Твоим будет видно «в отпуске до ${date} 🏝». Раз в неделю я всё равно тихо напишу тебе.`,
  forecast_time: 'Утренний прогноз',
  save_error: 'Не сохранилось. Попробуй ещё раз 🐾',
  feed: 'Покормить Луню 🍖',
  feed_sub: 'она будет рада',
  data_card: 'Мои данные',
  name: 'Имя',
  gender: 'Пол',
  birth_date: 'Дата рождения',
  add: 'дополнить ›',
  birth_time: 'Время рождения',
  birth_city: 'Город рождения',
  birth_change_title: 'Поменять дату рождения?',
  birth_change_body:
    'Пересчитаю карту заново — знак, три кита и дома могут стать другими. Прошлые прогнозы и проверки останутся как были.',
  birth_change_ok: 'Поменять',
  birth_change_cancel: 'Оставить как есть',
  // Сервер не принял данные рождения. Ирония выключена (правило 19): это отказ, а не шутка.
  birth_error_age: 'Дату рождения не сохранила: пользоваться приложением можно с четырнадцати лет.',
  birth_error_future: 'Дату рождения не сохранила: такой даты ещё не было.',
  birth_error_city: 'Город рождения не нашёлся. Выбери его из списка.',
  natal_link: 'Моя натальная карта',
  about: 'О Луне',
  privacy: 'Приватность',
  support: 'Поддержка',
  history: ({ gender }) => textByGender(gender, 'Кого ты проверял{|а}', 'Твои проверки'),
}
